import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "./AbstractValidation";
import { isFileManagementField } from "./isFileManagementField";

export abstract class FileAbstractValidation extends AbstractValidation {
  abstract isValidFile: (file: File) => boolean;
  abstract fileErrorMessage: (fileLabel: string) => string;

  getFiles(value: ValidationInputType): File[] {
    if (!value) {
      return [];
    }

    if (typeof value === "string") {
      return [];
    }
    const valueAsAny = value as any;
    if (isFileManagementField(valueAsAny)) {
      return Array.from(valueAsAny.files.filter((file) => !file.deleted && file.file)).map(
        (file) => file.file
      );
    }
    return Array.from(value);
  }
}
